module.exports = __webpack_public_path__ + "img/img3.0bce3237.png";